module.exports = __webpack_public_path__ + "img/0Q3A4612_L_Wood_MockedUp.0552d3ad.jpg";